import * as s from "./StatsStyled";
import * as Interface from "api/interfaces/dashboardInterface.interface";
import { Layout, Responsive, WidthProvider } from "react-grid-layout";
import "react-grid-layout/css/styles.css";
import SummaryCard from "./card/SummaryCard";
import * as cc from "pages/dashboard/stats/ChartControlStyled";
import AddChart from "./graph/AddChart";
import { Switch } from "antd";
import { LuFilter } from "react-icons/lu";
import GridChartItem from "./graph/GridChartItem";

const ResponsiveReactGridLayout = WidthProvider(Responsive);

interface Props {
  cardData: Interface.CardData[];
  graphLayouts: {
    [key in Interface.BreakpointKey]: Layout[];
  };
  breakpoints: Record<Interface.BreakpointKey, number>;
  cols: Record<Interface.BreakpointKey, number>;
  noticeHeight: number;
  isDraggable: boolean;
  cardLayouts: Layout[];
  onAddLayout: (selectedChartList: Layout[]) => void;
  isMobile: boolean;
  hiddenCharts: Interface.CardInfo[];
  onReplaceChart: (currentChartId: string, newChartId: string) => void;
  onRemoveChart: (chartId: string) => void;
  onChangeGraphType: (key: string, type: string) => void;
  showAddRemove: boolean;
  onToggleAddLayout: () => void;
  collapsed: boolean;
  includeSuspended: boolean;
  setIncludeSuspended: React.Dispatch<React.SetStateAction<boolean>>;
  onChangeDragAndResize: (layout: Interface.StatsLayout[]) => void;
}

export default function StatsPresenter(props: Props): JSX.Element {
  return (
    <s.Container
      noticeHeight={props.noticeHeight}
      isDraggable={props.isDraggable}
    >
      <s.StatsFixBar
        noticeHeight={props.noticeHeight}
        collapsed={props.collapsed}
      >
        <LuFilter />
        Include Suspended
        <Switch
          onChange={() => props.setIncludeSuspended(!props.includeSuspended)}
          checked={props.includeSuspended}
          data-testid="dashboard-stats-include-suspended-switch"
        />
      </s.StatsFixBar>
      <SummaryCard
        cardLayouts={props.cardLayouts}
        includeSuspended={props.includeSuspended}
      />

      <ResponsiveReactGridLayout
        autoSize
        className="layout chart-layout"
        breakpoints={props.breakpoints}
        cols={props.cols}
        layouts={props.graphLayouts}
        preventCollision={false}
        isDraggable={!props.isMobile}
        isResizable={!props.isMobile}
        compactType="horizontal"
        margin={[15, 15]}
        containerPadding={[0, 0]}
        isBounded={true}
        rowHeight={380}
        onDragStop={(layout) => {
          props.onChangeDragAndResize(layout);
        }}
        onResizeStop={(layout) => {
          props.onChangeDragAndResize(layout);
        }}
        draggableHandle=".drag-handle"
        resizeHandle={
          <s.ResizeHandle className="resize-handle react-resizable-handle" />
        }
      >
        {props.cardData.map((item) => {
          const widgetProps: Interface.GridChartItem = {
            item: item,
            onReplaceChart: props.onReplaceChart,
            onRemoveChart: props.onRemoveChart,
            hiddenCharts: props.hiddenCharts,
            onChangeGraphType: props.onChangeGraphType,
            onToggleAddLayout: props.onToggleAddLayout,
            showAddRemove: props.showAddRemove,
            includeSuspended: props.includeSuspended,
          };
          return (
            <div key={item.key}>
              <GridChartItem {...widgetProps} />
            </div>
          );
        })}
      </ResponsiveReactGridLayout>
      {!props.isMobile && (
        <cc.FlowButtonWrapper>
          <AddChart
            cardData={props.cardData}
            hiddenCharts={props.hiddenCharts}
            onAddLayout={props.onAddLayout}
            onToggleAddLayout={props.onToggleAddLayout}
            showAddRemove={props.showAddRemove}
          />
        </cc.FlowButtonWrapper>
      )}
    </s.Container>
  );
}
